exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-row-stats {\n  font-size: 12px;\n}\n", ""]);

